//GET WALLET-STATEMENT BY USER-ID
export const GET_WALLET_STATEMENT_REQUEST = "GET_WALLET_STATEMENT_REQUEST";
export const GET_WALLET_STATEMENT_SUCCESS = "GET_WALLET_STATEMENT_SUCCESS";
export const GET_WALLET_STATEMENT_FAILURE = "GET_WALLET_STATEMENT_FAILURE";